import { useQuery } from '@tanstack/react-query';
import { looksApi } from '../api/looks.js';

/**
 * Reading the looks also moves them on: the server picks up finished sheets, draws the
 * next ones and starts the waiting artwork. The builder page keeps this query mounted
 * on every step, so the chain advances wherever the owner is.
 */
export function useBookLooks(bookId: string, enabled = true) {
  return useQuery({
    queryKey: ['book-looks', bookId],
    queryFn: () => looksApi.list(bookId),
    enabled: enabled && Boolean(bookId),
    refetchInterval: (query) => {
      const data = query.state.data;
      return data &&
        (data.planStatus === 'queued' ||
          data.planStatus === 'running' ||
          [...data.items, ...(data.subjects ?? [])].some(
            (l) => l.status === 'queued' || l.status === 'running',
          ))
        ? 3000
        : false;
    },
  });
}
